import * as React from 'react';

var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var SvgStoreEyeTest = function SvgStoreEyeTest(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    "aria-hidden": "true",
    className: "store-eye-test_svg__icon store-eye-test_svg__icon--store-eye-test"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M18.75 0A2.25 2.25 0 0 1 21 2.25v19.5A2.25 2.25 0 0 1 18.75 24H5.25A2.25 2.25 0 0 1 3 21.75V2.25A2.25 2.25 0 0 1 5.25 0h13.5ZM4.5 2.25a.75.75 0 0 1 .75-.75h13.5a.75.75 0 0 1 .75.75v19.5a.75.75 0 0 1-.75.75H5.25a.75.75 0 0 1-.75-.75V2.25ZM12 4.5a.75.75 0 0 0-.75.75V6h2.25a.75.75 0 0 1 0 1.5h-2.25v.75c0 .414.336.75.75.75h1.5a.75.75 0 0 1 0 1.5H12a2.25 2.25 0 0 1-2.25-2.25v-3A2.25 2.25 0 0 1 12 3h1.5a.75.75 0 0 1 0 1.5H12ZM6 19.75a.75.75 0 0 1 .75-.75h1.5a.75.75 0 0 1 0 1.5h-1.5a.75.75 0 0 1-.75-.75Zm4.5 0a.75.75 0 0 1 .75-.75h1.5a.75.75 0 0 1 0 1.5h-1.5a.75.75 0 0 1-.75-.75Zm5.25-.75a.75.75 0 0 0 0 1.5h1.5a.75.75 0 0 0 0-1.5h-1.5Zm-9-7a.75.75 0 0 0-.75.75v4a.75.75 0 0 0 1.5 0V15.5h2.75a.75.75 0 0 0 0-1.5H7.5v-.5h2.75a.75.75 0 0 0 0-1.5h-3.5Zm6.923.004a.75.75 0 0 0-.673.746v4a.75.75 0 0 0 1.5 0V16h2.75a.75.75 0 0 0 .75-.75v-2.5a.75.75 0 0 0-.75-.75h-3.5a.747.747 0 0 0-.077.004ZM16.5 14.5h-2v-1h2v1Z",
    clipRule: "evenodd"
  })));
};

export { SvgStoreEyeTest as default };
//# sourceMappingURL=store-eye-test.svg.js.map
